/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

import getStore from 'SourceUtil/Store';

/** @namespace Nationalidnumber/Util/NationalIdNumber/isNationalIdNumberEnabled */
export const isNationalIdNumberEnabled = () => {
    const {
        ConfigReducer: {
            national_id_number_enabled,
            national_id_number_min_order_amount
        },
        CartReducer: {
            cartTotals: {
                prices: {
                    grand_total: {
                        value: grand_total
                    }
                }
            } = {}
        }
    } = getStore().getState();

    return national_id_number_enabled && grand_total >= parseFloat(national_id_number_min_order_amount);
};
